import {
    DateRange,
    IQueryString,
    LocationPickerSelection,
} from '../../../shared/models';

export class AccountingRefundFilter implements IQueryString {
    private size = 50;
    private page = 1;

    constructor(
        public date: DateRange,
        public locationsSelection?: LocationPickerSelection) { }

    toQueryString() {

        this.locationsSelection = this.locationsSelection || new LocationPickerSelection();

        return `${this.date.toQueryString()}&${this.locationsSelection.toQueryString()}&page=${this.page}&size=${this.size}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/models/accounting-refunds-filter.ts